import React from "react";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";

import JwtClient from "./JwtClient";
import Logout from "./utils";
import Alert from "./Alert";

export default class CarrierSelection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alert: '',
            loading: true,
            rules: [],
            carriers: [],
            cards: [],
            cardIdx: 0, // GOFO card shown
            miCard: null, // UPS Mail Innovations rate card
            fuel: null, // UPS MI fuel surcharge: {pct, updated_at, stale, history}
            fuelInput: '',
            fuelSaving: false,
            fuelHistoryOpen: false,
        };
    }

    render() {
        if (this.state.loading) {
            return (
                <div className="d-flex justify-content-center mt-4">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            )
        }
        const card = this.state.cards[this.state.cardIdx];
        return (
            <Container>
                {this.state.alert ? <Alert>{this.state.alert}</Alert> : null}
                {this.renderFuel()}
                <h4 className="mt-4 mb-2">How the carrier is selected</h4>
                <ol>
                    {this.state.rules.map((r, i) => <li key={i}>{r}</li>)}
                </ol>

                <h4 className="mt-4 mb-2">Carriers</h4>
                <Table size="sm">
                    <thead>
                    <tr>
                        <th>Carrier</th>
                        <th>Mail class</th>
                        <th>Markup</th>
                        <th>Markup is added on</th>
                        <th>Not marked up</th>
                        <th>Notes</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.carriers.map(c => (
                        <tr key={c.carrier + c.mail_class}>
                            <td>{c.carrier}</td>
                            <td>{c.mail_class}</td>
                            <td>{c.markup_pct}%</td>
                            <td>{c.markup_on}</td>
                            <td>{c.surcharges}</td>
                            <td>{(c.notes || []).map((n, i) => <div key={i}>{n}</div>)}</td>
                        </tr>
                    ))}
                    </tbody>
                </Table>

                {this.renderMICard()}

                {card ? <div>
                    <h4 className="mt-4 mb-2">GOFO rate cards</h4>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="btn-group">
                            {this.state.cards.map((c, i) => (
                                <button key={c.version}
                                        className={"btn btn-outline-secondary" + (i === this.state.cardIdx ? " active" : "")}
                                        onClick={() => this.setState({cardIdx: i})}>{c.version}</button>
                            ))}
                        </div>
                        <button className="btn btn-primary" onClick={() => this.downloadCSV(card, 'gofo-rates-' + card.version)}>Download CSV</button>
                    </div>
                    <p className="text-muted">{card.name}. Source: {card.source}. Prices in USD by zone.</p>
                    <Table size="sm" striped>
                        <thead>
                        <tr>
                            <th>Weight</th>
                            {card.zones.map(z => <th key={z}>Zone {z}</th>)}
                        </tr>
                        </thead>
                        <tbody>
                        {card.rows.map(r => (
                            <tr key={r.row}>
                                <td>{r.row}</td>
                                {r.cents.map((c, i) => <td key={i}>{(c / 100).toFixed(2)}</td>)}
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </div> : null}
            </Container>
        )
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        return JwtClient.get(`/api/v1/admin/carrier-selection-rules`)
            .then(response => {
                const d = response.data;
                this.setState({
                    rules: d.rules, carriers: d.carriers, cards: d.gofo_rate_cards,
                    miCard: d.upsmi_rate_card, fuel: d.upsmi_fuel_surcharge,
                    fuelInput: String(d.upsmi_fuel_surcharge.pct),
                });
            })
            .catch(err => {
                if (err.response) {
                    if (err.response.status === 401) {
                        Logout();
                    }
                    this.setState({alert: 'Error on fetching, status: ' + err.response.status});
                } else {
                    this.setState({alert: JSON.stringify(err)});
                }
            })
            .finally(() => {
                this.setState({loading: false});
            })
    }

    renderFuel() {
        const f = this.state.fuel;
        if (!f) {
            return null;
        }
        const updated = new Date(f.updated_at);
        const days = Math.floor((Date.now() - updated.getTime()) / 86400000);
        const pct = parseFloat(this.state.fuelInput);
        const valid = !isNaN(pct) && pct >= 0 && pct < 100 && pct !== f.pct;
        return (
            <div className={"card mt-4 " + (f.stale ? "border-danger" : "")}>
                <div className={"card-body " + (f.stale ? "bg-danger text-white" : "")}>
                    <h5 className="card-title">UPS Mail Innovations fuel surcharge</h5>
                    <p className="mb-2">
                        Now <b>{f.pct}%</b> of the base and the surcharges. Changed {updated.toLocaleDateString()} ({days} days ago).
                        {f.stale ? <b> Not updated for more than a month, check the new value on the UPS Mail Innovations site.</b> : null}
                    </p>
                    <div className="form-inline">
                        <input type="number" step="0.01" min="0" max="99.99" className="form-control mr-2" style={{width: '8rem'}}
                               value={this.state.fuelInput}
                               onChange={e => this.setState({fuelInput: e.target.value})}/>
                        <span className="mr-2">%</span>
                        <button className={"btn mr-3 " + (f.stale ? "btn-light" : "btn-primary")}
                                disabled={!valid || this.state.fuelSaving} onClick={this.saveFuel}>Save</button>
                        <button className={"btn btn-link " + (f.stale ? "text-white" : "")}
                                onClick={() => this.setState({fuelHistoryOpen: !this.state.fuelHistoryOpen})}>
                            {this.state.fuelHistoryOpen ? 'Hide history' : 'History'}
                        </button>
                    </div>
                    {this.state.fuelHistoryOpen ? (
                        <Table size="sm" className="mt-2 mb-0 bg-white" style={{maxWidth: '24rem'}}>
                            <thead><tr><th>Changed</th><th>%</th></tr></thead>
                            <tbody>
                            {f.history.map((h, i) => (
                                <tr key={i}><td>{new Date(h.created_at).toLocaleString()}</td><td>{h.pct}</td></tr>
                            ))}
                            </tbody>
                        </Table>
                    ) : null}
                </div>
            </div>
        )
    }

    renderMICard() {
        const card = this.state.miCard;
        if (!card) {
            return null;
        }
        return (
            <div>
                <h4 className="mt-4 mb-2">UPS Mail Innovations rate card</h4>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <p className="text-muted mb-0">{card.name} {card.version}. Source: {card.source}. Prices in USD by USPS zone.</p>
                    <div>
                        <button className="btn btn-outline-secondary mr-2"
                                onClick={() => this.downloadFile('/api/v1/admin/carrier-selection-rules/upsmi-zones.csv', 'upsmi-zones-from-079.csv')}>
                            Download zones CSV
                        </button>
                        <button className="btn btn-outline-secondary mr-2"
                                onClick={() => this.downloadFile('/api/v1/admin/carrier-selection-rules/upsmi-das.csv', 'upsmi-das-zips.csv')}>
                            Download DAS ZIPs CSV
                        </button>
                        <button className="btn btn-primary" onClick={() => this.downloadCSV(card, 'upsmi-rates-' + card.version.replace(/\s+/g, '-'))}>
                            Download CSV
                        </button>
                    </div>
                </div>
                <Table size="sm" striped>
                    <thead>
                    <tr>
                        <th>Weight</th>
                        {card.zones.map(z => <th key={z}>Zone {z}</th>)}
                    </tr>
                    </thead>
                    <tbody>
                    {card.rows.map(r => (
                        <tr key={r.row}>
                            <td>{r.row}</td>
                            {r.cents.map((c, i) => <td key={i}>{(c / 100).toFixed(2)}</td>)}
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </div>
        )
    }

    saveFuel = () => {
        this.setState({fuelSaving: true, alert: ''});
        JwtClient.post(`/api/v1/admin/upsmi-fuel-surcharge`, {pct: parseFloat(this.state.fuelInput)})
            .then(() => this.load())
            .catch(err => {
                if (err.response) {
                    if (err.response.status === 401) {
                        Logout();
                    }
                    const errs = err.response.data && err.response.data.errors;
                    this.setState({alert: errs ? errs.join('; ') : 'Error on saving, status: ' + err.response.status});
                } else {
                    this.setState({alert: JSON.stringify(err)});
                }
            })
            .finally(() => this.setState({fuelSaving: false}));
    };

    // the files are big and not shown on the page, they are only downloaded
    downloadFile = (url, name) => {
        JwtClient.get(url, {responseType: 'blob', timeout: 120000})
            .then(response => this.saveBlob(response.data, name))
            .catch(err => {
                if (err.response && err.response.status === 401) {
                    Logout();
                }
                this.setState({alert: 'Error on downloading ' + name + (err.response ? ', status: ' + err.response.status : '')});
            });
    };

    downloadCSV = (card, name) => {
        const header = ['weight'].concat(card.zones.map(z => 'zone_' + z));
        const lines = [header].concat(card.rows.map(r => [r.row].concat(r.cents.map(c => (c / 100).toFixed(2)))));
        this.saveBlob(new Blob([lines.map(l => l.join(',')).join('\n') + '\n'], {type: 'text/csv'}), `${name}.csv`);
    };

    saveBlob = (blob, name) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };
}
